import DSSCardioMedication from 'dashboard/templates/views/DSS/DSSCardioMedication';

export default {
  path: 'cardio-medication',
  name: 'DSSCardioMedication',
  component: DSSCardioMedication,
  meta: {
    // title: 'MDSS - Cardio Medication',
    title: (t) => `MDSS - ${t('myWeekMedication.cardioMedication', 'app_mobile')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  }
};
